import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp } from 'react-icons/fa';

const Footer = ({ t, scrollToSection, onAdminClick }) => {
  const socialLinks = [
    { icon: <FaFacebook />, url: '#' },
    { icon: <FaInstagram />, url: '#' },
    { icon: <FaLinkedin />, url: '#' },
    { icon: <FaWhatsapp />, url: 'https://wa.me/919123860262' }
  ];

  const quickLinks = [
    { name: t.nav.home, section: 'home' },
    { name: t.nav.about, section: 'about' },
    { name: t.nav.services, section: 'services' },
    { name: t.nav.gallery, section: 'gallery' },
    { name: t.nav.contact, section: 'contact' }
  ];

  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col lg={4} md={6} className="mb-4 scroll-fade-left">
            <h5 className="mb-3">
              <span className="animate-heartbeat">🏥</span> Physio Sphere
            </h5>
            <p className="mb-3 scroll-fade-up">
              Dedicated to providing comprehensive physiotherapy services with a patient-centered approach. 
              Your recovery is our priority.
            </p>
            <div className="social-links stagger-animation">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link hover-bounce animate-elastic"
                  style={{'--i': index}}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </Col>

          <Col lg={2} md={6} className="mb-4 scroll-fade-up">
            <h6 className="mb-3">{t.footer.quickLinks}</h6>
            <ul className="footer-links stagger-animation">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button 
                    onClick={() => scrollToSection(link.section)}
                    style={{ 
                      background: 'none', 
                      border: 'none', 
                      color: 'white', 
                      textDecoration: 'none',
                      padding: 0,
                      cursor: 'pointer',
                      '--i': index
                    }}
                    className="footer-link-btn hover-glow animate-slide-up"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </Col>

          <Col lg={3} md={6} className="mb-4 mt-4">
            <h6 className="mb-3">{t.contact.info.address}</h6>
            <p className="mb-2">{t.contact.details.addressText}</p>
            <p className="mb-2">{t.contact.details.phoneText}</p>
            <p className="mb-2">{t.contact.details.emailText}</p>
          </Col>

          <Col lg={3} md={6} className="mb-4">
            <h6 className="mb-3">{t.contact.info.hours}</h6>
            <p className="mb-2">{t.contact.details.hoursText}</p>
            <p className="mb-0">Sunday: Closed</p>
          </Col>
        </Row>

        <hr className="my-4" style={{ borderColor: 'rgba(255,255,255,0.2)' }} />

        <Row className="align-items-center">
          <Col md={8}>
            <p className="mb-0">{t.footer.copyright}</p>
          </Col>
          <Col md={4} className="text-end">
            <p className="mb-0">Made with ❤️ for better health</p>
          </Col>
        </Row>

        <button 
          className="admin-access hidden"
          onClick={onAdminClick}
        >
          k-admin
        </button>
      </Container>
    </footer>
  );
};

export default Footer;